import {memo} from 'react';
import {useIntl} from 'react-intl';

import {sendToStatist} from '@time-webkit/statist';
import {ContentCopy} from '@time-webkit/all/icons/content-copy';
import {ButtonCopyToClipboard} from 'components/button-copy-to-clipboard';

import {type InvitationResult} from './invitation_result';

type Props = {
    containerId: string;
    invitationResult: InvitationResult[];
}

export const CopyEmailsButton = memo(({invitationResult, containerId}: Props) => {
    const {formatMessage} = useIntl();

    return (
        <ButtonCopyToClipboard
            containerId={containerId}
            size='medium'
            copyText={invitationResult.map((item) => item.email).join(' ')}
            icon={<ContentCopy width={16} height={16} />}
            messageSuccess={formatMessage({
                id: 'invite.members.list_has_been_copied',
                defaultMessage: 'List has been copied',
            })}
            onClick={() => sendToStatist('team.invite.email.copy', {emailcnt: invitationResult.length})}
        >
            {formatMessage({
                id: 'invite.members.copy_email_list',
                defaultMessage: 'Copy the list of email addresses',
            })}
        </ButtonCopyToClipboard>
    );
});
